export default __webpack_public_path__ + "static/6824-8d516165b74a769c44aef610ec112832.jpg";